import styled, { css } from 'styled-components';
import * as tokens from '@pleo-io/telescope-tokens';
import { shade600, lineHeight2, shade700, lineHeight3, shade800, lineHeight1, fontWeightRegular, fontWeightSemibold, fontWeightMedium, fontWeightBold } from '@pleo-io/telescope-tokens';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    color: ", ";\n    /* stylelint-disable scale-unlimited/declaration-strict-value */\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", ";\n    ", ";\n    /* stylelint-enable */\n    i,\n    em {\n        font-style: italic;\n    }\n\n    b,\n    strong {\n        font-weight: ", ";\n    }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-bottom: ", "px;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n        text-transform: uppercase;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        font-style: italic;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n        text-align: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var truncate = function truncate(_ref) {
  var truncate = _ref.truncate;
  return truncate && css(_templateObject());
};

var align = function align(_ref2) {
  var align = _ref2.align;
  return align && css(_templateObject2(), align);
};

var italic = function italic(_ref3) {
  var italic = _ref3.italic;
  return italic && css(_templateObject3());
};

var uppercase = function uppercase(_ref4) {
  var uppercase = _ref4.uppercase;
  return uppercase && css(_templateObject4());
};

var space = function space(_ref5) {
  var space = _ref5.space;
  return space && css(_templateObject5(), space);
};

var getFontWeight = function getFontWeight(weight) {
  return weight ? Weights[weight] : fontWeightRegular;
};

var Weights = {
  regular: fontWeightRegular,
  medium: fontWeightMedium,
  semibold: fontWeightSemibold,
  bold: fontWeightBold
};
var textColors = ['shade000', 'shade600', 'shade700', 'shade800', 'shade900', 'red700', 'green800', 'inherit'];
var darkTextColors = ['shade000', 'shade600', 'shade700', 'shade800', 'shade900'];
var variants = {
  'xsmall-subtle': {
    size: 10,
    color: shade600,
    colors: textColors,
    lineHeight: lineHeight2,
    weights: ['bold', 'regular', 'medium', 'semibold']
  },
  'small-subtle': {
    size: 12,
    color: shade600,
    colors: textColors,
    lineHeight: lineHeight2,
    weights: ['regular', 'medium', 'semibold', 'bold']
  },
  'medium-default': {
    size: 14,
    color: shade700,
    colors: textColors,
    lineHeight: lineHeight3,
    weights: ['regular', 'medium', 'semibold', 'bold']
  },
  'large-accent': {
    size: 16,
    color: shade800,
    colors: darkTextColors,
    lineHeight: lineHeight1,
    weights: ['regular', 'medium', 'semibold', 'bold']
  },
  'xlarge-accent': {
    size: 18,
    color: shade800,
    colors: darkTextColors,
    lineHeight: lineHeight1,
    weights: ['regular', 'medium', 'semibold', 'bold']
  },
  '2xlarge-accent': {
    size: 20,
    color: shade800,
    colors: darkTextColors,
    lineHeight: lineHeight1,
    weights: ['regular', 'medium', 'semibold', 'bold']
  },
  '3xlarge-accent': {
    size: 24,
    color: shade800,
    colors: darkTextColors,
    lineHeight: lineHeight1,
    weights: ['regular', 'medium', 'semibold', 'bold']
  },
  '4xlarge-accent': {
    size: 32,
    color: shade800,
    colors: darkTextColors,
    lineHeight: lineHeight1,
    weights: ['regular', 'medium']
  },
  '5xlarge-accent': {
    size: 48,
    color: shade800,
    colors: darkTextColors,
    lineHeight: lineHeight1,
    weights: ['regular', 'medium']
  }
};

function getTextColor(_ref6) {
  var color = _ref6.color,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'medium-default' : _ref6$variant;
  var defaultVariantColor = variants[variant].color;

  if (!color) {
    return defaultVariantColor;
  }

  return variants[variant].colors.includes(color) ? tokens[color] : defaultVariantColor;
}

var Text = /*#__PURE__*/styled.div.attrs(function (props) {
  return {
    as: props.as || 'div'
  };
})( /*#__PURE__*/_templateObject6(), align, truncate, space, italic, uppercase, getTextColor, function (_ref7) {
  var weight = _ref7.weight;
  return getFontWeight(weight);
}, function (_ref8) {
  var _ref8$variant = _ref8.variant,
      variant = _ref8$variant === void 0 ? 'medium-default' : _ref8$variant;
  return variants[variant].size;
}, function (_ref9) {
  var _ref9$variant = _ref9.variant,
      variant = _ref9$variant === void 0 ? 'medium-default' : _ref9$variant;
  return variants[variant].lineHeight;
}, function (props) {
  var _props$variant;

  return ['xsmall-subtle', 'small-subtle', 'medium-default'].includes((_props$variant = props.variant) != null ? _props$variant : 'medium-default') ? uppercase(props) : '';
}, fontWeightSemibold);
export { Text, variants };